import { Component, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { BaseControlValueAccessor } from "../base_control_value_accessor/base";

@Component({
  selector: 'app-text-field',
  templateUrl: './text-field.component.html',
  styleUrls: ['../form-field.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => TextFieldComponent),
    }
  ]
})
export class TextFieldComponent extends BaseControlValueAccessor implements OnInit {

  expanding: boolean = false;

  @Input()
  minlength: number = -1;

  @Input()
  maxlength: number = 10000;

  @Input()
  isMultiline: boolean = false;

  @Input()
  emailIcon: boolean = false;
  @Input()
  searchIcon: boolean = false;
  @Input()
  tableDesc: boolean = false;
  @Input()
  dualLine: boolean = false;

  @Input()
  specailChar: boolean = false;// to set if the container number field

  @Output()
  focusOut = new EventEmitter<any>();

  @ViewChild('chatter') chating: ElementRef;
  constructor() {
    super();
  }

  ngOnInit(): void {
  }

  override get data() {
    return this._data
  }

  override set data(val) {
    this._data = val;
    this.validate(val);
    this.onChange(val);
  }

  expand() {
    this.expanding = !this.expanding;
  }

  focusoutfn() {
    this.expand();
    this.focusOut.emit();
  }

  readableFileSize(size) {
    var units = ['B', 'KB', 'MB'];
    var i = 0;
    while (size >= 1024) {
      size /= 1024;
      ++i;
    }
    return size?.toFixed(2) + ' ' + units[i];
  }

  getDisplay() {
    if (this.data == null || this.data == undefined) {
      return '-';
    } else {
      return this.data
    }
  }

  focusInput() {
    this.chating.nativeElement.focus();
  }

  default(event) {
    if (this.specailChar) {
      if ((event.keyCode >= 33 && event.keyCode <= 47) || (event.keyCode >= 48 && event.keyCode <= 64) || (event.keyCode >= 91 && event.keyCode <= 96) || (event.keyCode >= 123 && event.keyCode <= 126)) {
        event.preventDefault();
      }
    }
  }

  override validate(str) {
    this.errors = [];
    // if (str.length<0) {
    //   this.ifError = false;
    // }
    if (str?.length < this.minlength && str?.length > 0) {
      this.errors.push(`Minimum length ${this.minlength}`);
    }

    if (str?.length > this.maxlength) {
      this.errors.push(`Maximum length ${this.maxlength}`);
    }
  }

}
